import {Room as BookingRoom} from '../../api-types/bovio/response/booking'
import {Room} from '../../api-types/bovio/response/offer_check'
import {Room as ContentRoom, RoomWithoutOffers} from '../../room/types/room'

/**
 * Adapts offer check room data to the standard room format used in the application
 * @param offerCheckRoom - Room data from offer check API response
 * @returns Standardized room object
 */
export const adaptOfferCheckRoom = (
  offerCheckRoom: Room
): RoomWithoutOffers => {
  const {occupancy, displayName, id, masterId, area, ...rest} = offerCheckRoom

  return {
    ...rest,
    id: id || '',
    masterId: masterId || '',
    area: area
      ? {
          squareMeters: area.squareMeters || undefined,
          squareFeet: area.squareFeet || undefined
        }
      : undefined,
    bedTypes: [],
    name: displayName || '',
    occupationPerRoom: occupancy?.maxAdults || 0
  }
}

/**
 * Adapts existing booking room data to the standard room format used in the application
 * @param bookingRoom - Room data from booking API response
 * @param contentRoom - Matching room from SAPI, the only source of images,
 * description and amenities, which the booking response does not carry
 * @returns Standardized room object
 */
export const adaptExistingBookingRoom = (
  bookingRoom: BookingRoom,
  contentRoom?: ContentRoom
): RoomWithoutOffers => {
  const {id, masterId, guests, mealPlan, ...rest} = bookingRoom

  return {
    ...rest,
    id: id || '',
    masterId: masterId || '',
    amenities: contentRoom?.amenities ?? [],
    amenitiesList: contentRoom?.amenitiesList,
    area: contentRoom?.area,
    bedrooms: contentRoom?.bedrooms,
    bedTypes: [],
    description: contentRoom?.description ?? '',
    images: contentRoom?.images ?? [],
    guests,
    occupationPerRoom: guests?.adults || 0,
    mealPlan: mealPlan ?? []
  }
}
